import { useCallback } from 'react';
import { userSelector } from 'redux/selectors';
import { useSelector } from 'react-redux';

export const useSocialAuth = (isInvite) => {
  const currentUser = useSelector(userSelector);

  return useCallback(
    (user) => {
      if (isInvite && currentUser?.id !== user?.id) {
        const message =
          'This invitation is linked to a different [Google/LinkedIn] account. Make sure you’re using the account that received the invite.';
        const error = new Error(message);
        error.status = 401;
        error.data = {
          error: message,
        };
        throw error;
      }
    },
    [currentUser, isInvite],
  );
};
